export const assessmentQuestions = {
  foundation: {
    title: "Foundation Section",
    questions: [
      {
        id: "foundation_1",
        question: "How often do you follow through on commitments you make to yourself?",
        options: [
          { text: "Almost always - I consistently keep my self-commitments", score: 0 },
          { text: "Usually - I follow through most of the time", score: 1 },
          { text: "Sometimes - I have mixed results with self-commitments", score: 2 },
          { text: "Rarely - I frequently break commitments to myself", score: 3 }
        ]
      },
      {
        id: "foundation_2",
        question: "How clear are you about your most important goals and priorities?",
        options: [
          { text: "Very clear - I know exactly what matters most", score: 0 },
          { text: "Mostly clear - I have a good sense of my priorities", score: 1 },
          { text: "Somewhat unclear - my priorities shift frequently", score: 2 },
          { text: "Very unclear - I struggle to identify what's truly important", score: 3 }
        ]
      },
      {
        id: "foundation_3",
        question: "How effective are your current systems for tracking progress toward goals?",
        options: [
          { text: "Very effective - I have robust tracking systems that work well", score: 0 },
          { text: "Somewhat effective - I track some things but could be better", score: 1 },
          { text: "Minimally effective - I have basic tracking but it's inconsistent", score: 2 },
          { text: "Ineffective - I don't have reliable systems for tracking progress", score: 3 }
        ]
      },
      {
        id: "foundation_4",
        question: "How often do you maintain motivation and momentum toward your goals?",
        options: [
          { text: "Consistently - I maintain steady motivation most of the time", score: 0 },
          { text: "Frequently - I maintain momentum with occasional dips", score: 1 },
          { text: "Occasionally - my motivation comes and goes unpredictably", score: 2 },
          { text: "Rarely - I struggle to maintain motivation for more than a few days", score: 3 }
        ]
      },
      {
        id: "foundation_5",
        question: "How do you typically respond when you encounter obstacles or setbacks?",
        options: [
          { text: "I adapt quickly and find alternative solutions", score: 0 },
          { text: "I work through obstacles with some difficulty but persist", score: 1 },
          { text: "I get stuck for a while but eventually find a way forward", score: 2 },
          { text: "I often get derailed and struggle to get back on track", score: 3 }
        ]
      },
      {
        id: "foundation_6",
        question: "How satisfied are you with your current rate of progress toward your important goals?",
        options: [
          { text: "Very satisfied - I'm making excellent progress", score: 0 },
          { text: "Mostly satisfied - good progress with room for improvement", score: 1 },
          { text: "Somewhat dissatisfied - progress is slower than I'd like", score: 2 },
          { text: "Very dissatisfied - I feel stuck and not making meaningful progress", score: 3 }
        ]
      },
      {
        id: "foundation_7",
        question: "How confident are you in your ability to plan and execute complex projects or goals?",
        options: [
          { text: "Very confident - I excel at planning and execution", score: 0 },
          { text: "Mostly confident - I'm good at planning and usually execute well", score: 1 },
          { text: "Somewhat confident - I can plan but struggle with consistent execution", score: 2 },
          { text: "Not confident - I struggle with both planning and execution", score: 3 }
        ]
      },
      {
        id: "foundation_8",
        question: "How often do you make excuses or avoid taking responsibility when you don't meet your goals?",
        options: [
          { text: "Never - I take full responsibility for my results", score: 0 },
          { text: "Rarely - I occasionally make excuses but generally own my results", score: 1 },
          { text: "Sometimes - I make excuses more often than I'd like to admit", score: 2 },
          { text: "Frequently - I often find external reasons for not meeting my goals", score: 3 }
        ]
      }
    ]
  },
  clarity: {
    title: "Clarity & Simplification Section",
    questions: [
      {
        id: "clarity_1",
        question: "How often do you feel overwhelmed by the sheer number of commitments, activities, and responsibilities you've taken on?",
        options: [
          { text: "Rarely - I manage my commitments well", score: 0 },
          { text: "Occasionally - sometimes feel stretched thin", score: 1 },
          { text: "Several times per week - regularly feel overloaded", score: 2 },
          { text: "Daily/constantly - I'm drowning in commitments", score: 3 }
        ]
      },
      {
        id: "clarity_2",
        question: "How much does your physical/digital environment currently support your most important goals?",
        options: [
          { text: "Strongly supports me - environment is optimized for success", score: 0 },
          { text: "Neutral - doesn't particularly help or hurt", score: 1 },
          { text: "Somewhat hinders me - mixed support with notable barriers", score: 2 },
          { text: "Actively works against me - constant distractions/obstacles", score: 3 }
        ]
      },
      {
        id: "clarity_3",
        question: "When trying to achieve important goals, how comfortable are you with saying 'no' and eliminating activities that don't serve your priorities?",
        options: [
          { text: "Very comfortable - regularly eliminate to maintain focus", score: 0 },
          { text: "Moderately comfortable - can eliminate when necessary", score: 1 },
          { text: "Somewhat uncomfortable - can eliminate obvious non-essentials", score: 2 },
          { text: "Very uncomfortable - struggle to eliminate anything", score: 3 }
        ]
      }
    ]
  },
  action: {
    title: "Action & Execution Section",
    questions: [
      {
        id: "action_1",
        question: "When you decide to work toward a goal, how quickly do you typically take your first meaningful action?",
        options: [
          { text: "Within hours - I act immediately on decisions", score: 0 },
          { text: "Within 24-48 hours - relatively quick to start", score: 1 },
          { text: "Within a few days - some delay but eventual action", score: 2 },
          { text: "Days/weeks later - I procrastinate on starting", score: 3 }
        ]
      },
      {
        id: "action_2",
        question: "How consistent are you with taking small daily actions toward your goals, even when you don't feel motivated?",
        options: [
          { text: "Very consistent - rarely miss daily actions", score: 0 },
          { text: "Mostly consistent - occasional lapses", score: 1 },
          { text: "Somewhat inconsistent - good days and bad days", score: 2 },
          { text: "Very inconsistent - only when I feel motivated", score: 3 }
        ]
      },
      {
        id: "action_3",
        question: "When facing a large or intimidating goal, how comfortable are you with breaking it down into the smallest possible daily actions?",
        options: [
          { text: "Very comfortable - always start with minimum viable actions", score: 0 },
          { text: "Comfortable - naturally think in smaller steps", score: 1 },
          { text: "Somewhat comfortable - can break down with effort", score: 2 },
          { text: "Very uncomfortable - prefer to tackle things in big chunks", score: 3 }
        ]
      }
    ]
  },
  support: {
    title: "Support & Accountability Section",
    questions: [
      {
        id: "support_1",
        question: "How open are you to forming mutual accountability relationships where others regularly check on your progress and you do the same for them?",
        options: [
          { text: "Very open - actively seek accountability partnerships", score: 0 },
          { text: "Somewhat open - see the value but have concerns", score: 1 },
          { text: "Somewhat resistant - prefer minimal external accountability", score: 2 },
          { text: "Very resistant - prefer to work independently", score: 3 }
        ]
      },
      {
        id: "support_2",
        question: "How willing are you to intentionally put yourself in uncomfortable situations to accelerate your growth?",
        options: [
          { text: "Very willing - actively seek growth challenges", score: 0 },
          { text: "Somewhat willing - can push myself when needed", score: 1 },
          { text: "Somewhat unwilling - only when absolutely necessary", score: 2 },
          { text: "Very unwilling - prefer to stay in my comfort zone", score: 3 }
        ]
      }
    ]
  },
  optimization: {
    title: "Optimization & Systems Section",
    questions: [
      {
        id: "optimization_1",
        question: "How much do you rely on tracking data and metrics to make decisions about your goals and strategies?",
        options: [
          { text: "Consistently - make most decisions based on solid data", score: 0 },
          { text: "Regularly - track key metrics and review periodically", score: 1 },
          { text: "Occasionally - some tracking but inconsistent analysis", score: 2 },
          { text: "Rarely - I go by gut feel and general impressions", score: 3 }
        ]
      },
      {
        id: "optimization_2",
        question: "How willing are you to create meaningful stakes (financial, social, etc.) tied to your goal achievement to ensure follow-through?",
        options: [
          { text: "Very willing - believe in meaningful consequences for results", score: 0 },
          { text: "Somewhat willing - could see value in small stakes", score: 1 },
          { text: "Somewhat unwilling - prefer internal motivation only", score: 2 },
          { text: "Very unwilling - don't want external consequences", score: 3 }
        ]
      }
    ]
  }
};